import {
  DuplicateLanguagesMode,
  DuplicateQuestionnaireInput,
} from 'src/graphql';

const INTERNAL_NAME_MAX_LENGTH = 100;
const ALLOWED_CHARS = /[^a-zA-Z0-9\s_-]/g;

export function buildDuplicateInput(
  title: string,
  mode: 'all-languages' | 'default-only' = 'default-only',
): DuplicateQuestionnaireInput {
  const timestamp = Date.now();
  const suffix = ` - Copy ${timestamp}`;
  const sanitizedName = title
    .replace(ALLOWED_CHARS, '')
    .slice(0, INTERNAL_NAME_MAX_LENGTH - suffix.length);

  return {
    internalName: `${sanitizedName}${suffix}`,
    publicTitle: title,
    duplicateLanguages:
      mode === 'all-languages'
        ? DuplicateLanguagesMode.All
        : DuplicateLanguagesMode.Default,
  };
}
